export default "__VITE_ASSET__CKHFx8ls__"